import React from 'react';
import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'


const PerguntaCard = ({ pergunta, idPerfilAcesso, remover, permiteAdicionarAlterarResponsavel }) => {
    
    return (
        <div className={styles.wrapper}>

            {
                (pergunta.pergunta !== null && pergunta.pergunta !== "undefined" && pergunta.pergunta !== "") &&
                <>
                    <div className={styles.title}>
                        Pergunta:
                    </div>
                    <div className={styles.info}>
                        {pergunta.pergunta}
                    </div>
                </>
            }

            {
                (pergunta.ordem !== null && pergunta.ordem !== "undefined" && pergunta.ordem !== "") &&
                <>
                    <div className={styles.title}>
                        Ordem:
                    </div>
                    <div className={styles.info}>
                        {pergunta.ordem}
                    </div>
                </>
            }

            {
                (pergunta.resposta1 !== null && pergunta.resposta1 !== "undefined" && pergunta.resposta1 !== "") &&
                <>
                    <div className={styles.title}>
                        Resposta 1:
                    </div>
                    <div className={styles.info}>
                        {pergunta.resposta1}
                    </div>
                </>
            }

            {
                (pergunta.resposta2 !== null && pergunta.resposta2 !== "undefined" && pergunta.resposta2 !== "") &&
                <>
                    <div className={styles.title}>
                        Resposta 2:
                    </div>
                    <div className={styles.info}>
                        {pergunta.resposta2}
                    </div>
                </>
            }

            {
                (pergunta.resposta3 !== null && pergunta.resposta3 !== "undefined" && pergunta.resposta3 !== "") &&
                <>
                    <div className={styles.title}>
                        Resposta 3:
                    </div>
                    <div className={styles.info}>
                        {pergunta.resposta3}
                    </div>
                </>
            }

            {
                (pergunta.resposta3Correta !== null && pergunta.resposta3Correta !== "undefined" && pergunta.resposta3Correta !== "") &&
                <>
                    <div className={styles.title}>
                        Resposta Correta:
                    </div>
                    <div className={styles.info}>
                    {pergunta.respostaCorreta}
                    </div>
                </>
            }

            {
                (permiteAdicionarAlterarResponsavel === undefined || permiteAdicionarAlterarResponsavel) &&
                <button className={styles.apagar} onClick={remover}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            }
        </div>
    )
}

export default PerguntaCard